import { apiURl } from "./apiconfig";

const getOrdersRequest = (token) => {
  const url = apiURl + "orders/dispatcher/getall";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getCustomerOrderHistoryRequest = (token, phone, portalOrganizationId) => {
  const query = new URLSearchParams({
    phone,
    ...(portalOrganizationId ? { portalOrganizationId } : {}),
  });
  const url = apiURl + "orders/dispatcher/customer/history?" + query.toString();
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getMenuCategoriesRequest = (
  token,
  restaurantId,
  menuType = 2,
  portalOrganizationId = null
) => {
  let url =
    apiURl +
    "orders/dispatcher/menu/categories?restaurantId=" +
    restaurantId +
    "&menuType=" +
    menuType;
  if (portalOrganizationId) {
    url += "&portalOrganizationId=" + portalOrganizationId;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getFinishedOrdersRequest = (token, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const url = apiURl + "orders/dispatcher/finished/getall?" + qs.toString();
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getTopCustomersRequest = (token, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const url = apiURl + "orders/dispatcher/finished/topcustomers?" + qs.toString();
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getFinishedOrderDetailsRequest = (token, id) => {
  const url = apiURl + "orders/dispatcher/finished/" + id;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const updateOrderStatusRequest = (token, orderId, status) => {
  const url =
    apiURl +
    "orders/dispatcher/updateStatus?orderId=" +
    orderId +
    "&status=" +
    status;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getOrdersUpdatesRequest = (token) => {
  const url = apiURl + "orders/dispatcher/getorderUpdates";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getDriversRequest = (token, orderId) => {
  const url = apiURl + "drivers?orderId=" + orderId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const updateOrderDriverRequest = (token, orderId, driverId, driverName) => {
  const url =
    apiURl +
    "orders/dispatcher/setDriver?orderId=" +
    orderId +
    "&driverId=" +
    driverId +
    "&driverName=" +
    driverName;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const deleteOrderRequest = (token, orderId, note) => {
  const url =
    apiURl + "orders/dispatcher/delete?orderId=" + orderId + "&message=" + note;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const toggleDeliveryEnabledRequest = (token, newValue) => {
  const url = apiURl + "portalorganizations/" + newValue;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getDeliveryEnabledRequest = (token) => {
  const url = apiURl + "portalorganizations";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getMenuItemsRequest = (
  token,
  restaurantId,
  menuType = 2,
  portalOrganizationId = null
) => {
  let url =
    apiURl +
    "orders/dispatcher/menu/items?restaurantId=" +
    restaurantId +
    "&menuType=" +
    menuType;
  if (portalOrganizationId) {
    url += "&portalOrganizationId=" + portalOrganizationId;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getItemModifiersRequest = (token, restaurantId, itemId, menuType = 2) => {
  const url =
    apiURl +
    "orders/dispatcher/menu/modifiers?restaurantId=" +
    restaurantId +
    "&itemId=" +
    itemId +
    "&menuType=" +
    menuType;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const createOrderByDispatcherRequest = (token, orderData) => {
  const url = apiURl + "orders/dispatcher/create";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(orderData),
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

export {
  getOrdersRequest,
  updateOrderStatusRequest,
  getOrdersUpdatesRequest,
  getFinishedOrdersRequest,
  getFinishedOrderDetailsRequest,
  getTopCustomersRequest,
  getDriversRequest,
  updateOrderDriverRequest,
  deleteOrderRequest,
  toggleDeliveryEnabledRequest,
  getDeliveryEnabledRequest,
  getMenuItemsRequest,
  getMenuCategoriesRequest,
  getItemModifiersRequest,
  createOrderByDispatcherRequest,
  getCustomerOrderHistoryRequest,
};
